import {
  AdditionalOption,
  BasicOption,
  OldAdditionalOption,
  ParkingType,
  PropertyType,
} from './room'
import { RoomIconName } from '../ui/room-icon/icon'

export const PROPERTY_TYPE_MAP = {
  [PropertyType.OFFICETEL]: '오피스텔',
  [PropertyType.APARTMENT]: '아파트',
  [PropertyType.STUDIO]: '원룸건물',
  [PropertyType.VILLA]: '연립빌라',
  [PropertyType.DETACHED]: '단독주택',
  [PropertyType.MIXED_USE]: '상가주택',
  [PropertyType.GOSIWON]: '고시원',
  [PropertyType.HOTEL]: '호텔',
  [PropertyType.MOTEL]: '모텔여관',
  [PropertyType.VACATION_HOME]: '펜션',
  [PropertyType.GUEST_HOUSE]: '게스트하우스',
  [PropertyType.SHARE_HOUSE]: '쉐어하우스',
}

export const PARKING_TYPE_MAP = {
  [ParkingType.FREE_LEEWAY]: '무료 주차(여유)',
  [ParkingType.FREE_FIRST_COME]: '무료 주차(선착순)',
  [ParkingType.PAID]: '유료 주차',
  [ParkingType.NONE]: '주차 불가능',
}

export const BASIC_OPTION_MAP: Record<
  BasicOption,
  { label: string; icon: RoomIconName }
> = {
  [BasicOption.REFRIGERATOR]: {
    label: '냉장고',
    icon: 'refrigerator',
  },
  [BasicOption.WASHING_MACHINE]: {
    label: '세탁기',
    icon: 'washingMachine',
  },
  [BasicOption.AIR_CONDITIONER]: {
    label: '에어컨',
    icon: 'airConditioner',
  },
  [BasicOption.TV]: {
    label: 'TV',
    icon: 'tv',
  },
  [BasicOption.WIFI]: {
    label: '와이파이',
    icon: 'wifi',
  },
  [BasicOption.SINK]: {
    label: '싱크대',
    icon: 'sink',
  },
  [BasicOption.GAS_STOVE]: {
    label: '가스레인지',
    icon: 'gasStove',
  },
  [BasicOption.INDUCTION]: {
    label: '인덕션',
    icon: 'induction',
  },
  [BasicOption.BED]: {
    label: '침대',
    icon: 'bed',
  },
}

export const ADDITIONAL_OPTION_MAP: Record<
  AdditionalOption,
  { label: string; icon: RoomIconName }
> = {
  [AdditionalOption.DOOR_LOCK]: {
    label: '도어락',
    icon: 'doorlock',
  },
  [AdditionalOption.CCTV]: {
    label: 'CCTV',
    icon: 'cctv',
  },
  [AdditionalOption.MANAGEMENT_OFFICE]: {
    label: '관리실',
    icon: 'managementOffice',
  },
  [AdditionalOption.DINING_TABLE]: {
    label: '식탁',
    icon: 'diningTable',
  },
  [AdditionalOption.MICROWAVE]: {
    label: '전자레인지',
    icon: 'microwave',
  },
  [AdditionalOption.RICE_COOKER]: {
    label: '전기밥솥',
    icon: 'riceCooker',
  },
  [AdditionalOption.WATER_PURIFIER]: {
    label: '정수기',
    icon: 'waterPurifier',
  },
  [AdditionalOption.SOFA]: {
    label: '소파',
    icon: 'sofa',
  },
  [AdditionalOption.DESK]: {
    label: '책상',
    icon: 'desk',
  },
  [AdditionalOption.CLOSET]: {
    label: '옷장',
    icon: 'closet',
  },
  [AdditionalOption.SHOE_RACK]: {
    label: '신발장',
    icon: 'shoeRack',
  },
  [AdditionalOption.VANITY]: {
    label: '화장대',
    icon: 'vanity',
  },
  [AdditionalOption.BATHTUB]: {
    label: '욕조',
    icon: 'bathtub',
  },
  [AdditionalOption.BIDET]: {
    label: '비데',
    icon: 'bidet',
  },
  [AdditionalOption.DRYER]: {
    label: '건조기',
    icon: 'dryer',
  },
  [AdditionalOption.BALCONY]: {
    label: '발코니/베란다',
    icon: 'balcony',
  },
  [AdditionalOption.DRESSING_ROOM]: {
    label: '드레스룸',
    icon: 'dressingRoom',
  },
  [AdditionalOption.CABLE_TV]: {
    label: '케이블 TV',
    icon: 'cableTV',
  },
  [AdditionalOption.CURTAINS]: {
    label: '커튼',
    icon: 'curtain',
  },
  [AdditionalOption.AIR_PURIFIER]: {
    label: '공기청정기',
    icon: 'airPurifier',
  },
  [AdditionalOption.PET_ALLOWED]: {
    label: '반려동물 동반',
    icon: 'petAllowed',
  },
}

export const OLD_ADDITIONAL_OPTION_MAP: Record<
  OldAdditionalOption,
  { label: string; icon?: RoomIconName }
> = {
  ...ADDITIONAL_OPTION_MAP,
  [OldAdditionalOption.COOLING_HEATING_SYSTEM]: {
    label: '냉난방기',
  },
  [OldAdditionalOption.HEATER]: {
    label: '히터',
  },
  [OldAdditionalOption.IRON]: {
    label: '다리미',
  },
  [OldAdditionalOption.ELECTRIC_KETTLE]: {
    label: '전기포트',
  },
  [OldAdditionalOption.TABLEWARE]: {
    label: '식기류',
  },
  [OldAdditionalOption.COOKWARE]: {
    label: '조리도구',
  },
  [OldAdditionalOption.HAIR_DRYER]: {
    label: '드라이기',
  },
}

export const OPTION_MAP = {
  ...BASIC_OPTION_MAP,
  ...ADDITIONAL_OPTION_MAP,
  ...OLD_ADDITIONAL_OPTION_MAP,
}
